<div class="folder-roles-list">
    <div>
        <strong>Folder-Level Roles</strong><br />
        Take effect only when applied to Folders<br />
    </div>
    <mat-expansion-panel *ngFor="let role of FolderLevelRoles" [hideToggle]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="role-title" title="Role ID {{role.id}}">
                    <span class="role-member-count">
                        <mat-icon title="Role Members" class="role-member-count-icon">group</mat-icon>
                    </span>
                </div>
                <div>
                    <strong class="role-name" title="Role ID {{role.id}}">{{role.name}}</strong>
                </div>
            </mat-panel-title>
            <mat-panel-description class="role-buttons">
                <mat-icon style="visibility: hidden;">space_bar</mat-icon>
                <mat-icon (click)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                          tabindex="0"
                          (keyup.enter)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                          title="Edit Role Details">edit</mat-icon>
                <mat-icon (click)="deleteRole($event, role)"
                          tabindex="1"
                          (keyup.enter)="deleteRole($event, role)"
                          title="Delete Role">delete</mat-icon>
            </mat-panel-description>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <br />
    Manage role members on the <span class="tab-change" (click)="OpenFRMtab()">Folders, Roles, and Members</span> tab.
    <br /><br />
    <button class="new-role-btn theme-primary-btn" mat-flat-button color="primary" (click)="this.openCreateRoleDialog()">New Role</button>
</div>
